export const changeCheckboxes = () => {
	const checkboxesFields = document.querySelectorAll("input[type='checkbox']");

	checkboxesFields.forEach(field => {
		field.addEventListener("change", e => {
			field.classList.toggle("checked");

			if (!field.classList.contains("js-purchase-checkbox")) {
				field.value = Number(field.classList.contains("checked"));
			}
		});
	});
}
